import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.login');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-login',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.login/view.scss */
:host {
  display: block;
  height: 100%;
}

.login-bg, .login-panel-bg {
  background: #FFF8F1;
}

.login-orb {
  position: absolute;
  border-radius: 50%;
  opacity: 0.15;
  pointer-events: none;
}

.login-orb-1 {
  width: 320px;
  height: 320px;
  background: radial-gradient(circle, #fff 0%, transparent 70%);
  top: -80px;
  right: -60px;
  animation: loginOrbFloat1 8s ease-in-out infinite;
}

.login-orb-2 {
  width: 200px;
  height: 200px;
  background: radial-gradient(circle, #fff 0%, transparent 70%);
  bottom: 10%;
  left: -40px;
  animation: loginOrbFloat2 10s ease-in-out infinite;
}

.login-orb-3 {
  width: 140px;
  height: 140px;
  background: radial-gradient(circle, #FFE0B2 0%, transparent 70%);
  top: 40%;
  right: 20%;
  animation: loginOrbFloat3 7s ease-in-out infinite;
}

@keyframes loginOrbFloat1 {
  0%, 100% {
    transform: translate(0, 0) scale(1);
  }
  50% {
    transform: translate(-30px, 40px) scale(1.1);
  }
}
@keyframes loginOrbFloat2 {
  0%, 100% {
    transform: translate(0, 0) scale(1);
  }
  50% {
    transform: translate(20px, -30px) scale(1.05);
  }
}
@keyframes loginOrbFloat3 {
  0%, 100% {
    transform: translate(0, 0) scale(1);
    opacity: 0.15;
  }
  50% {
    transform: translate(-15px, 20px) scale(1.15);
    opacity: 0.25;
  }
}
.login-card {
  animation: loginCardFadeIn 0.6s ease-out;
}

@keyframes loginCardFadeIn {
  from {
    opacity: 0;
    transform: translateY(1.5rem) scale(0.97);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
.login-icon-wrapper {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  padding: 0.75rem;
  background: rgba(255, 152, 72, 0.12);
  animation: loginIconBounce 0.8s ease-out 0.3s both, loginIconGlow 3s ease-in-out 1.1s infinite;
}

@keyframes loginIconBounce {
  0% {
    opacity: 0;
    transform: scale(0.5) translateY(-1rem);
  }
  60% {
    opacity: 1;
    transform: scale(1.1) translateY(0);
  }
  100% {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}
@keyframes loginIconGlow {
  0%, 100% {
    box-shadow: 0 0 0 0 rgba(255, 152, 72, 0.15);
    transform: scale(1);
  }
  50% {
    box-shadow: 0 0 24px 8px rgba(255, 152, 72, 0.3);
    transform: scale(1.06);
  }
}`],
})
export class PageLoginComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public data: any = {
        email: '',
        password: ''
    };

    public toast: any = { message: '', type: '', show: false };
    private toastTimer: any = null;
    public isLoading: boolean = false;

    public async ngOnInit() {
        await this.service.init();
        let check = await this.service.auth.check();
        if (check) {
            location.href = "/center/solution";
            return;
        }
    }

    public async showToast(message: string, type: string = 'success') {
        if (this.toastTimer) clearTimeout(this.toastTimer);
        this.toast = { message, type, show: true };
        await this.service.render();
        this.toastTimer = setTimeout(async () => {
            this.toast.show = false;
            await this.service.render();
        }, 3000);
    }

    public async login() {
        let user = JSON.parse(JSON.stringify(this.data));
        if (!user.email) {
            await this.showToast("이메일을 입력해주세요.", "error");
            return;
        }
        if (!user.password) {
            await this.showToast("비밀번호를 입력해주세요.", "error");
            return;
        }

        this.isLoading = true;
        await this.service.render();

        let { code, data } = await wiz.call("login", user);

        this.isLoading = false;

        if (code == 200) {
            await this.showToast("로그인 성공", "success");
            setTimeout(() => {
                location.href = "/center/solution";
            }, 1000);
        } else {
            await this.showToast(data?.message || "로그인 실패", "error");
            await this.service.render();
        }
    }
}

export default PageLoginComponent;